import { Wind } from "lucide-react";
import FloatingTool from "./FloatingTool";

// ClinBreath: asistente ventilatorio (ventilador con perillas + ondas + OCR por visión).
export default function FloatingClinBreath() {
  return (
    <FloatingTool
      src="/clinbreath.html"
      title="ClinBreath · Asistente ventilatorio"
      label="ClinBreath"
      Icon={Wind}
      colorClass="bg-blue-600"
      shadowClass="shadow-blue-600/30"
      bottomClass="bottom-[25rem]"
    />
  );
}
